import React from "react";
import { Portal } from "@mui/material";
import Confetti from "react-confetti";
import DialogWindow from "components/other/DialogWindow";
import { useGetState, useSetState } from "components/ReduxProvider";
import { useSaleExpiration } from "./subscriptionHooks";
import { useViewerQuery } from "queries/viewerQuery";
import { isNoPaymentTimezone } from "components/other/VpnAffiliate";
import { SALE } from "sharedJs__generated/constants";
import SaleDialogDefault from "./SaleDialogDefault";
import SaleDialogBlackFriday from "./SaleDialogBlackFriday";

type Props = {};

const SaleDialog: React.FC<Props> = () => {
  const closeSale = useGetState("closeSale");
  const setCloseSale = useSetState("closeSale");
  const { saleExpiration, saleId, saleActive, withoutDialog } = useSaleExpiration();
  const { viewer } = useViewerQuery();

  // Common conditions for all sale dialogs
  if (
    closeSale ||
    viewer?.subscription ||
    !saleActive ||
    isNoPaymentTimezone(viewer?.timezone) ||
    !saleExpiration ||
    withoutDialog
  )
    return null;

  // Specific conditions for default sale dialog (not Black Friday)
  if (saleId !== SALE.blackFriday && (viewer?.installReferrer || saleId === SALE.motherLangDay)) return null;

  const handleClose = () => setCloseSale(true);

  const isBlackFriday = saleId === SALE.blackFriday;

  return (
    <>
      <Portal>
        <Confetti
          confettiSource={{ x: 0, y: 0, w: window.innerWidth, h: 150 }}
          numberOfPieces={80}
          gravity={0.15}
          recycle={false}
          opacity={0.7}
          style={{ zIndex: 1310 }} // right behind snackbar
        />
      </Portal>
      <DialogWindow open onClose={handleClose} closeIconStyle={isBlackFriday ? { color: "#aaaaaa" } : undefined}>
        {isBlackFriday ? <SaleDialogBlackFriday onClose={handleClose} /> : <SaleDialogDefault onClose={handleClose} />}
      </DialogWindow>
    </>
  );
};

export default SaleDialog;
